import { Button } from "primereact/button";
import React from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { stack } from "@ui/style";

export const CreateTemplateCard: React.FC<{ onCreateNewTemplateRequest: () => void }> = ({
	onCreateNewTemplateRequest,
}) => {
	const { format } = useI18n();
	return (
		<ButtonCard>
			<CardTitle className="p-size-m-bold">{format("home.pendingPatientDialog.codeSent.bottomCard.title")}</CardTitle>
			<CardText className="p-size-s">{format("home.pendingPatientDialog.codeSent.bottomCard.text")}</CardText>
			<Button
				label={format("home.pendingPatientDialog.codeSent.bottomCard.cta")}
				onClick={onCreateNewTemplateRequest}
			/>
		</ButtonCard>
	);
};

const ButtonCard = styled.div`
	background-color: ${colors.primaryBackground};
	border-radius: 8px;
	padding: 24px;
	align-items: center;
	${stack(undefined, "center", "center")}
`;

const CardTitle = styled.p`
	text-align: center;
	margin-bottom: 4px;
`;

const CardText = styled.p`
	text-align: center;
	margin-bottom: 16px;
`;
